<template>
  <div>
    <p v-if="ticketList && ticketList.length > 0">关联工单</p>

    <div v-if="ticketList && ticketList.length > 0"
        class="box-border-7">
        <div
            style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"
            v-for="each in ticketList"
            :key="each.id">
            <TicketTitle
            :ticketTitle="each.orderTitle"
            :ticketNo="each.orderId"
            target="_blank"/>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "LinkedTicketList",

    props: ['ticketNo'],

    data() {
        return {
            ticketList: []
        };
    },

    watch: {
        ticketNo() {
            this.loadLinkedTicketList();
        }
    },

    methods: {
        loadLinkedTicketList() {
            if ( !this.ticketNo ) {
                console.log('#20 LinkedTicketList ticketNo=', this.ticketNo);
                return;
            }

            var _this = this;
            sdk.TicketLinkApi().listLinkedTicket({
                no: _this.ticketNo
            }).then(res => {
                _this.ticketList = res || [];
            });
        }
    },

    mounted() {
        this.loadLinkedTicketList();
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/LinkedTicketList.vue